// extracted by mini-css-extract-plugin
export default {"wrapper":"users-indicator_wrapper__S4Vmt","opacity-transition":"users-indicator_opacity-transition__fKzE-"};